var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" " + _vm._s(_vm.edit ? "Editar" : "Cadastrar") + " Organograma ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_vm.visible ? _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da Gerência*",
      "maxlength": "40",
      "counter": "40",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return !!v || 'Campo obrigatório';
      }]
    },
    model: {
      value: _vm.content.nome,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nome", $$v);
      },
      expression: "content.nome"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sigla da Gerência*",
      "maxlength": "12",
      "counter": "12",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return !!v || 'Campo obrigatório';
      }]
    },
    model: {
      value: _vm.content.sigla,
      callback: function ($$v) {
        _vm.$set(_vm.content, "sigla", $$v);
      },
      expression: "content.sigla"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.form.lists.secretarias,
      "item-text": 'nome',
      "item-value": 'identificador',
      "rules": [function (v) {
        return !!v || 'Campo obrigatório';
      }],
      "label": "Secretaria Executiva*",
      "return-object": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.content.secretariaExecutiva,
      callback: function ($$v) {
        _vm.$set(_vm.content, "secretariaExecutiva", $$v);
      },
      expression: "content.secretariaExecutiva"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Setor(es)*",
      "items": _vm.form.lists.setores,
      "item-text": 'nome',
      "item-value": 'id',
      "rules": [function (v) {
        return v && v.length > 0 || 'Campo obrigatório';
      }],
      "return-object": "",
      "outlined": "",
      "multiple": "",
      "dense": ""
    },
    model: {
      value: _vm.content.setores,
      callback: function ($$v) {
        _vm.$set(_vm.content, "setores", $$v);
      },
      expression: "content.setores"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c('sigfoco-buttons', {
    attrs: {
      "actionText": 'Salvar'
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }